import { render, staticRenderFns } from "./TextInABox.vue?vue&type=template&id=52bd76a6&"
import script from "./TextInABox.vue?vue&type=script&lang=js&"
export * from "./TextInABox.vue?vue&type=script&lang=js&"
import style0 from "./TextInABox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextInABox.vue"
export default component.exports